import "./index.css";
const EmptyCol = () => {
    return (
        <div className="sf-min-width-empty-col">
        </div>
    )
};

export default EmptyCol;